/** Mirrors the API's limits, which are the ones enforced */
export const WhatsappCampaignLimits = {
  MAX_RECIPIENTS: 100,
  MIN_GAP_SECONDS: 30,
  MAX_GAP_SECONDS: 24 * 60 * 60,
} as const;
